/*

  A component for a list of items where scrolling through them
  invokes an action to load more items.

  The items are passed in as children and can be any React elements.

  Currently, it inserts a waypoint at the top of each batch of
  items, including the initial set of items (batch 1). Assuming the
  first item is visible on the page, this has the effect of
  immediately fetching the batch 2. Once batch 2 is loaded, the waypoint will be
  moved the top of its elements. When the user scrolls to this
  moved waypoint, batch 3 will be fetched and the waypoint moved to
  the top of batch 3's elements, and so on and so on, forever.

  Warning: Using the back button to go back to a page where this list has been
  used will have potentially confusing results.

  Props

  loadMoreAction - Required. Callback function to invoke when waypoint scrolls into view.
                   It should load the next batch of items.


 loadingInProgress - Required. If true, the loadMoreAction is busy and we will not try
                     to to call it again until this is false.

  noMoreItems - optional, default=false. If true, will not create any waypoints so the list
                will no longer call loadMoreAction.



  <InfiniteScrollList
    loadMoreAction={Actions.loadMoreThings}
    loadingInProgress={false}
    noMoreItems={false}>
    {[<Item key={1}/>,<Item key={2}/>...]}
  </InfiniteScrollList>

 */

import React from "react";
import GrComponentFactory from "../gr_component_factory";
import Waypoint from "react-waypoint";
import { isEmpty } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "InfiniteScrollList",

  propTypes: {
    loadMoreAction: React.PropTypes.func.isRequired,
    loadingInProgress: React.PropTypes.bool.isRequired,
    noMoreItems: React.PropTypes.bool,
  },

  getInitialState() {
    return {
      waypointIndex: 0,
    };
  },

  handleOnEnter() {
    if(!this.props.loadingInProgress){
      this.props.loadMoreAction();
    }
  },

  childrenWithWaypoint(children)  {
    const waypoint = <Waypoint key={`waypoint${children.length}`}
                             onEnter={this.handleOnEnter} />;
    children.splice(this.state.waypointIndex, 0, waypoint);
    return children;
  },

  renderWithWaypoint() {
    const children = React.Children.toArray(this.props.children);
    if (!isEmpty(children)) {
      if(this.props.noMoreItems === true) {
        return children;
      } else {
        return this.childrenWithWaypoint(children);
      }
    } else {
      return null;
    }
  },

  componentWillReceiveProps(nextProps) {
    if(nextProps.children.length !== this.props.children.length) {
      this.setState({
        waypointIndex: React.Children.count(this.props.children),
      });
    }
  },

  render() {
    return <div>
      {this.renderWithWaypoint()}
    </div>;
  },

});
